"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Subtitle2: function() {
        return _index.Subtitle2;
    },
    subtitle2ClassNames: function() {
        return _index.subtitle2ClassNames;
    }
});
const _index = require("./components/presets/Subtitle2/index");
